"use strict";
/**
 * Client Billing API - Response Types
 *
 * Response types for the client-facing billing portal endpoints.
 *
 * @see /api/client-billing/*
 */
Object.defineProperty(exports, "__esModule", { value: true });
